import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class FaaliyetListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "FaaliyetListe";
    super(baseUrl);
  }


  getFaaliyetListe( faaliyetKodu?: number){
    var request= new FaaliyetListeRequest( faaliyetKodu);
    
    return this.get("",request);
  }

}


export default new FaaliyetListeAPI();
class FaaliyetListeRequest {
  public faaliyetKodu?: number;

 
  constructor(faaliyetKodu?: number) {
   
      this.faaliyetKodu = faaliyetKodu;

      
  }
}
export { FaaliyetListeRequest };